import { fa, weekDayNames } from './week-day';
import { chunk } from './chunk';
import { daysInMonthEn } from './days-in-month.en';
import { daysInMonthFa } from './days-in-month.fa';
export { daysInMonthEn, daysInMonthFa, fa, weekDayNames, chunk, };
//# sourceMappingURL=index.js.map